<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-01 14:50:38
 * @LastEditTime: 2019-08-13 16:07:47
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="content">
         <div class="pageTitle">经销商库存统计 （统计数据非实时统计，更新截止到前一天）</div>
          <el-tabs v-model="activeName" type="card" >
    <el-tab-pane label="出货统计" name="1">
        <outPut/>  
    </el-tab-pane>
    <el-tab-pane label="零售统计" name="2">
        <retail/>
    </el-tab-pane>
    <el-tab-pane label="库存统计" name="3">
        <stock/>
    </el-tab-pane>
    <el-tab-pane label="呆滞品统计" name="4">
        <sluggish/>
    </el-tab-pane>
    <el-tab-pane label="效期统计" name="5">
        <Effective/>
    </el-tab-pane>

  </el-tabs>
    </div>

</template>

<script>
import  outPut from './components/outPut.vue'  
import  retail from './components/retail.vue'  
import  stock from './components/stock.vue'  
import  sluggish from './components/sluggish.vue'  
import  Effective from './components/Effective.vue'  




export default {
    data(){
       return{
           activeName:'1'
       } 
    },
    methods:{
        init(){
             if(this.$route.query.tab){
                        this.activeName=this.$route.query.tab
                    }
        }
    },
    created(){
        this.init()
    },
    components:{
outPut,retail,stock,sluggish,Effective
    }
}
</script>
